import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { FrmData } from '@/types';
import { getShowFlag, hiddenLoadPage, setMessage, showLoadPage } from '@/utils/messageUtils';
import storage from '@/utils/storage';
import axios from 'axios';
import qs from 'qs';
import { getAccessPrctCode, getActionId, getActionName, getFunctionId } from './requestInfo';

// axiosを新規
const service = axios.create({
  timeout: 3600000, // TimeOut時間
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  },
  // Add validateStatus to consider all status codes as successful
  validateStatus: function (status) {
    return true; // Always return true so that the success handler is called
  },
});

service.interceptors.request.use(
  (config) => {
    const token = storage.getItem('pxp_authToken');
    if (token && token.trim() !== '') {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['FunctionId'] = getFunctionId();
      config.headers['APIId'] = getActionId();
      config.headers['ActionName'] = getActionName();
      config.headers['AccessPrctCode'] = getAccessPrctCode();
    }
    //画面にLoading状態になる
    showLoadPage();
    if (getActionName() === 'checkStatus') {
      getShowFlag().showFlag = false;
    }
    return config;
  },
  (error) => {
    // Do something with request error
    hiddenLoadPage();
    // store.dispatch('app/setBtnLoading', !1);
    Promise.reject(error);
  },
);

let _fields: any = null;
let _backfields: any = null;

// Helper function to get nested field value by path
function getNestedField(obj: any, path: string): FrmData | null {
  if (!obj || !path) return null;

  try {
    return path
      .split(/[\.\[\]]/)
      .filter(Boolean)
      .reduce((current, key) => {
        return current && current[key] !== undefined ? current[key] : null;
      }, obj);
  } catch {
    return null;
  }
}

export function setfields(fields: any) {
  _fields = fields;
  _backfields = fields;
}

export function clearerr() {
  if (_backfields) {
    clearFieldsErr(_backfields);
  }
}

export function clearFieldsErr(fields: any) {
  if (fields) {
    const fieldKeys = fields.constructor.keys(fields);
    fieldKeys.forEach((key: any) => {
      const targetObject = getNestedField(fields, key);
      if (typeof targetObject === 'object' && targetObject && targetObject['errors']) {
        targetObject['errors'] = [];
      } else if (Array.isArray(targetObject)) {
        targetObject.forEach((item: any) => {
          Object.keys(item).forEach((key: any) => {
            const nestedObject = getNestedField(item, key);
            if (typeof nestedObject === 'object' && nestedObject && nestedObject['errors']) {
              nestedObject['errors'] = [];
            }
          });
        });
      }
    });
  }
}

service.interceptors.response.use(
  async (response) => {
    clearerr();
    const res = response.data;
    if (response.data.token) {
      const authStore = useAuthStore();
      authStore.updateToken(response.data.token);
    }
    hiddenLoadPage();
    // store.dispatch('app/setBtnLoading', !1);
    if (res.code == null) {
      //ダウンロードする際に、エラー発生する場合があるので、エラー処理を追加
      if (res.type === 'application/json') {
        const reader = new FileReader();
        reader.readAsText(response.data, 'utf-8');
        return new Promise((resolve, reject) => {
          reader.onload = async () => {
            try {
              const tempResult: any = reader.result;
              const error = JSON.parse(tempResult);

              // 400エラー（バリデーションエラー）の処理
              if (error.code === 400) {
                let alertFlg = true;

                // othersフィールドのエラー処理
                if (alertFlg && _fields && error.errinfo && error.errinfo.others) {
                  for (let i = 0; i < error.errinfo.others.length; i++) {
                    const filedName = error.errinfo.others[i];
                    const fomdata: FrmData | null = getNestedField(_fields, filedName);
                    // フィールドが存在し、detailMsgが存在する場合
                    if (fomdata && error.errinfo.detailMsg && error.errinfo.detailMsg[i]) {
                      const detailMsg = error.errinfo.detailMsg[i].map((msg: string) => {
                        // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
                        if (msg.startsWith('M-')) {
                          msg = msg.replace(/^M-.*\t/, '');
                        }
                        return msg;
                      });
                      fomdata.errors = fomdata.errors.concat(detailMsg);
                      alertFlg = false;
                    } else if (error.errinfo.detailMsg && error.errinfo.detailMsg[i]) {
                      error.errinfo.detailMsg.forEach((item: any) => {
                        setMessage({ message: item, type: 'error' });
                      });
                      alertFlg = false;
                    }
                  }
                }

                // validationErrorsの処理
                if (alertFlg && _fields && error.errinfo && error.errinfo.validationErrors) {
                  error.errinfo.validationErrors.forEach((item: any) => {
                    const fomdata: FrmData | null = getNestedField(_fields, item.fieldName);
                    if (fomdata && item.messages) {
                      const detailMsg = item.messages.map((msg: string) => {
                        // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
                        if (msg.startsWith('M-')) {
                          msg = msg.replace(/^M-.*\t/, '');
                        }
                        return msg;
                      });
                      fomdata.errors = fomdata.errors.concat(detailMsg);
                      alertFlg = false;
                    } else if (item.messages) {
                      item.messages.forEach((msg: string) => {
                        setMessage({ message: msg, type: 'error' });
                      });
                      alertFlg = false;
                    }
                  });
                }

                // 全てのフィールド処理が完了した後にfieldsをクリア
                _fields = null;

                // フィールドに関連付けられないエラーの場合、アラートメッセージを表示
                if (alertFlg) {
                  // detailMsgがある場合
                  if (error.errinfo && error.errinfo.detailMsg) {
                    error.errinfo.detailMsg.forEach((item: any) => {
                      setMessage({ message: item, type: 'error' });
                    });
                    alertFlg = false;
                  }
                  // validationErrorsがある場合
                  if (alertFlg && error.errinfo && error.errinfo.validationErrors) {
                    error.errinfo.validationErrors.forEach((item: any) => {
                      // メッセージが存在することを確認
                      if (item.messages && item.messages.length > 0) {
                        // エラータイプに応じてメッセージタイプを設定
                        if (item.errorType && item.errorType.indexOf('ERROR') !== -1) {
                          setMessage({ message: item.messages.join(', '), type: 'error' });
                        } else if (item.errorType && item.errorType.indexOf('WARNING') !== -1) {
                          setMessage({ message: item.messages.join(', '), type: 'warning' });
                        } else {
                          setMessage({ message: item.messages.join(', '), type: 'info' });
                        }
                      }
                    });
                    alertFlg = false;
                  }
                }
                reject('error');
                return;
              }

              // 401エラー（認証エラー）の処理
              if (error.code === 401) {
                if (error.errinfo && error.errinfo.detailMsg && error.errinfo.detailMsg.length > 0) {
                  setMessage({ message: error.errinfo.detailMsg[0], type: 'error' });
                } else if (error.message) {
                  setMessage({ message: error.message, type: 'error' });
                }
                _fields = null;
                error.data = [];
                reject('error');
                return;
              }

              // 404エラー（データが存在しない）の処理
              if (error.code === 404) {
                // データが存在しない場合、メッセージを表示する
                if (error.errinfo && error.errinfo.detailMsg && error.errinfo.detailMsg.length > 0) {
                  setMessage({ message: error.errinfo.detailMsg[0], type: 'info' });
                }
                _fields = null;
                error.data = [];
                reject(error); // Promise内ではresolveを使用
                return;
              }

              // 409エラー（競合エラー）の処理
              if (error.code === 409) {
                try {
                  await router.replace({ path: '/Info', query: { message: error.message, flag: error.code } });
                } catch (navError) {
                  console.error('Navigation to Info failed:', navError);
                }
                reject('error');
                return;
              }

              // 410エラー（リソースが存在しない）の処理
              if (error.code === 410) {
                try {
                  await router.replace({ path: '/Info', query: { message: error.message, flag: error.code } });
                } catch (navError) {
                  console.error('Navigation to Info failed:', navError);
                }
                reject('error');
                return;
              }

              // 500エラー（サーバーエラー）の処理
              if (error.code === 500) {
                let message = '';
                // detailMsgが存在することを確認
                if (error.errinfo && error.errinfo.detailMsg) {
                  error.errinfo.detailMsg.forEach((item: any) => {
                    // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
                    if (item.startsWith('M-')) {
                      item = item.replace(/^M-.*\t/, '');
                    }
                    message = message + '\n' + item;
                  });
                }
                try {
                  await router.replace({ path: '/SystemError', query: { message: message } });
                } catch (navError) {
                  window.location.href = `/SystemError?message=${encodeURIComponent(message)}`;
                }
                reject('error');
                return;
              }

              // その他のエラーの場合
              _fields = null;
              reject('error');
            } catch (parseError) {
              // JSONの解析に失敗した場合
              console.error('JSON解析エラー:', parseError);
              _fields = null;
              reject('error');
            }
          };

          // FileReaderのエラー処理
          reader.onerror = () => {
            console.error('Blobテキスト読み込みエラー');
            _fields = null;
            reject('error');
          };
        });
      }

      const fileName = window.decodeURI(response.headers['content-disposition'].match(/filename=(.*)/)[1]);
      const download: any = {};
      download.fileName = fileName;
      download.fileContent = response.data;
      return download;
    }

    if (res.code === 200) {
      _fields = null;
      if (res.message != null) {
        setMessage({ message: res.message, type: 'info' });
        return new Promise((resolve) => resolve(res));
      }
    }
    if (res.code === 400) {
      let alertFlg = true;
      if (_fields && res.errinfo.others) {
        for (let i = 0; i < res.errinfo.others.length; i++) {
          const filedName = res.errinfo.others[i];
          const fomdata: FrmData | null = getNestedField(_fields, filedName);

          if (fomdata) {
            const detailMsg = res.errinfo.detailMsg[i].map((msg: string) => {
              // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
              if (msg.startsWith('M-')) {
                msg = msg.replace(/^M-.*\t/, '');
              }
              return msg;
            });
            fomdata.errors = fomdata.errors.concat(detailMsg);
            alertFlg = false;
          } else {
            res.errinfo.detailMsg.forEach((msg: string) => {
              setMessage({ message: msg, type: 'error' });
            });
            alertFlg = false;
          }
        }
        _fields = null;
      }
      if (alertFlg && _fields && res.errinfo.validationErrors) {
        res.errinfo.validationErrors.forEach((item: any) => {
          const fomdata: FrmData | null = getNestedField(_fields, item.fieldName);
          if (fomdata) {
            const detailMsg = item.messages.map((msg: string) => {
              // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
              if (msg.startsWith('M-')) {
                msg = msg.replace(/^M-.*\t/, '');
              }
              return msg;
            });
            fomdata.errors = fomdata.errors.concat(detailMsg);
            alertFlg = false;
          } else {
            item.messages.forEach((msg: string) => {
              setMessage({ message: msg, type: 'error' });
            });
            alertFlg = false;
          }
        });
        _fields = null;
      }

      // チェックエラー TODO 具体的の処理を待ち
      if (alertFlg) {
        if (res.errinfo.detailMsg) {
          res.errinfo.detailMsg.forEach((item: any) => {
            setMessage({ message: item, type: 'error' });
          });
          alertFlg = false;
        }
        if (alertFlg && res.errinfo.validationErrors) {
          res.errinfo.validationErrors.forEach((item: any) => {
            // フィールドが存在しない場合、メッセージを表示
            if (item.errorType.indexOf('ERROR') !== -1) {
              // エラータイプがERRORの場合、メッセージを表示
              for (const message of item.messages) {
                setMessage({ message, type: 'error' });
              }
            } else if (item.errorType.indexOf('WARNING') !== -1) {
              // エラータイプがWARNINGの場合、メッセージを表示
              for (const message of item.messages) {
                setMessage({ message, type: 'warning' });
              }
            } else {
              // その他のエラータイプの場合、メッセージを表示
              for (const message of item.messages) {
                setMessage({ message, type: 'info' });
              }
            }
          });
          alertFlg = false;
        }
      }
      return Promise.reject('error');
    }
    if (res.code === 401) {
      if (res.errinfo && res.errinfo.detailMsg && res.errinfo.detailMsg.length > 0) {
        setMessage({ message: res.errinfo.detailMsg[0], type: 'error' });
      } else {
        setMessage({ message: res.message, type: 'error' });
      }
      _fields = null;
      res.data = [];
      return Promise.reject('error');
    }
    if (res.code === 404) {
      //データが存在しない場合、メッセージを表示する
      setMessage({ message: res.errinfo.detailMsg[0], type: 'info' });
      _fields = null;
      res.data = [];
      return Promise.resolve(res);
    }

    if (res.code === 409) {
      try {
        await router.replace({ path: '/Info', query: { message: res.message, flag: res.code } });
      } catch (navError) {
        console.error('Navigation to Info failed:', navError);
      }
      return Promise.reject('error');
    }
    if (res.code === 410) {
      try {
        await router.replace({ path: '/Info', query: { message: res.message, flag: res.code } });
      } catch (navError) {
        console.error('Navigation to Info failed:', navError);
      }
      return Promise.reject('error');
    }
    if (res.code === 500) {
      let message = '';
      res.errinfo.detailMsg.forEach((item: any) => {
        // メッセージが「M-」で始める場合、先頭、「M-.*\t」を削除する
        if (item.startsWith('M-')) {
          item = item.replace(/^M-.*\t/, '');
        }
        message = message + '\n' + item;
      });
      try {
        await router.replace({ path: '/SystemError', query: { message: message } });
      } catch (navError) {
        window.location.href = `/SystemError?message=${encodeURIComponent(message)}`;
      }
      return Promise.reject('error');
    }

    return res;
  },
  async (error) => {
    hiddenLoadPage();
    try {
      await router.replace({
        path: '/SystemError',
        query: {
          message:
            'Processing failure. Please contact the system administrator if no improvement is seen after trying again.',
        },
      });
    } catch (navError) {
      console.error('Navigation to SystemError failed:', navError);
      window.location.href = '/SystemError?message=';
    }
    return Promise.reject('error');
  },
);

export default service;
